import { render, staticRenderFns } from "./groupBuying.vue?vue&type=template&id=4a8cbd6a&scoped=true&"
import script from "./groupBuying.vue?vue&type=script&lang=js&"
export * from "./groupBuying.vue?vue&type=script&lang=js&"
import style0 from "./groupBuying.vue?vue&type=style&index=0&id=4a8cbd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8cbd6a",
  null
  
)

export default component.exports